import axiosClient from './axiosClient';

export const getStudents = (params?: Record<string, any>) => {
    return axiosClient.get('/students', { params });
};

export const getStudentById = (id: string | number) => {
    return axiosClient.get(`/students/${id}`);
};

export const createStudent = (data: Record<string, any>) => {
    return axiosClient.post('/students', data);
};

export const updateStudent = (id: string | number, data: Record<string, any>) => {
    return axiosClient.put(`/students/${id}`, data);
};

export const deleteStudent = (id: string | number) => {
    return axiosClient.delete(`/students/${id}`);
};

export const uploadStudentAvatar = (id: string, file: File) => {
    const formData = new FormData();
    formData.append('file', file);
    return axiosClient.post(`/students/${id}/avatar`, formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });
};

export const getStudentDashboardStatsById = (id: string) => {
    return axiosClient.get(`/students/${id}/dashboard-stats`);
};

export const getStudentTimetableById = (id: string) => {
    return axiosClient.get(`/students/${id}/timetable`);
};

export const transferStudentClass = (studentId: string, data: { from_class_id?: string | null; to_class_id: string; transfer_tuition_package?: boolean }) => {
    return axiosClient.post(`/students/${studentId}/transfer-class`, data);
};


